module.exports = __webpack_public_path__ + "img/3.52a3302c.jpg";